<ng-container *ngIf="backRoute || defaultBackRoute">
    <div [ngClass]="{ 'back-button': !fluentRefresh, 'back-button--fluent': fluentRefresh, 'ms-u-hiddenMdDown' : responsive && !fluentRefresh }">
        <ohp-icon-font [id]="elementId"
            [cssClass]="'back-button__icon ms-fcl-tp' + (fluentRefresh ? ' back-button__icon--fluent' : '')"
            iconFontName="ArrowLeft"
            iconButton="true"
            ariaVisible="true"
            [ariaLabel]= "backButtonAriaLabel || defaultAriaLabel"
            dataArea="Hero"
            dataNav=1
            (iconClicked)="navigateBack()"
            [title]="backButtonAriaLabel || defaultAriaLabel"
            [focusOnLoad]="focusOnLoad">
        </ohp-icon-font>
    </div>
</ng-container>
